module.exports = __webpack_public_path__ + "img/asus.d0879803.svg";